<template>

  <div class="recycle_container">
    <div class="detail_top" ref="pagesRef">
      <el-carousel :height="pagesHeight + 'px'" :autoplay="true" :interval="5000">
        <el-carousel-item v-for="(item,index) in detailImgList" :key="index">
          <img class="imgCls" :src="item.url">
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="detail_center_one">
      <div class="center_one_title">
        <div class="center_one_title_line"></div>
        <div class="center_one_title_content">智能积分售货机</div>
        <div class="center_one_title_line"></div>
      </div>

      <div class="center_one_body_current">
        <img style="width: 80%" class="oneBodyImgCls" src="../assets/images/blshj02_center_001.png"/>
      </div>

    </div>

    <div class="detail_center_two">

      <div class="center_two_a">
        <div class="center_two_a_left"></div>
        <div class="center_two_a_right"></div>
      </div>

      <div class="center_two_b">
        <div class="center_two_b_left"></div>
        <div class="center_two_b_center">智能积分售货机</div>
        <div class="center_two_b_right"></div>
      </div>

      <div class="center_two_c">
        <div class="center_two_c_a">
          智能售货机整体设计稳重大方，以人机工程学为依据设计操作面板整体布局，操作更加人性化。大面积橱窗展示礼品。让用户一目了然地选择礼品。用户通过刷分类积分卡，以积分兑换所需的礼品，此垃圾分类奖励模式更容易让用户所接受。
          <br>——智能售货机适用于机场、酒店、 办公室、车站、学校、医院、网吧等各种公共场所，自动供应食品，饮料，日用品等各种适当外形的百货商品。拥有智能售货机机，即拥有了一个自动化的小超市。
        </div>
      </div>

      <div class="center_two_d">外观尺寸</div>
      <div class="center_two_e">不加雨棚：1390mm(长)*900mm(宽)*1900mm(高)</div>
      <div class="center_two_e">加雨棚：1400mm(长)*1130mm(宽)*1940mm(高)</div>

      <div class="center_other_adorn_right">
        <img class="adorn_img" src="../assets/images/home_center_adorn.png">
      </div>


      <div class="center_two_d">应用场景</div>
      <div class="center_two_e">
        居民社区，公共场所，小区宽阔区域
      </div>

      <div class="center_two_d">功能</div>
      <div class="center_two_f">
        <img src="../assets/images/blshj02_center_002.png">
      </div>

    </div>

    <div class="detail_center_three">
      <div class="center_three_body_left">
        <div class="three_body_left_left">一</div>
        <div class="three_body_left_right">管 理云平台：可通过网络查询每一台兑换机的使用信息、运行状态，微电脑控制系统具备智能 数据查询、统计、核算、故障自诊断等管 理功能。</div>
      </div>

      <div class="center_three_body_right">
        <div class="three_body_right_left">二</div>
        <div class="three_body_right_right">多媒体宣传屏：标配21.5寸户外液晶广告显示屏，可播放各种各式的视频和图片。</div>
      </div>

      <div class="center_three_body_left">
        <div class="three_body_left_left">三</div>
        <div class="three_body_left_right">智能扫码装置：产品采用工业级二维码扫描器，反应更灵敏，使用寿命更长。</div>
      </div>

      <div class="center_three_body_right">
        <div class="three_body_right_left">四</div>
        <div class="three_body_right_right">多功能取物口：产品下部设有全包围式工程塑料取物口，美观的同时也可避免划伤；
          取物口上设有指示灯，当用户使用时指示灯亮起，便于用户取出物品，设计更加人性化。
        </div>
      </div>

      <div class="center_three_body_left">
        <div class="three_body_left_left">五</div>
        <div class="three_body_left_right">刷卡功能： 可通过刷卡领取垃圾袋或礼品等；也可以通过刷卡查询积分余额和用户信息。</div>
      </div>

    </div>

    <div class="detail_center_four">
      <img style="width: 50%;margin-top: 24px" src="../assets/images/blshj02_center_003.png"/>
      <div class="center_four_text">(可定制)</div>
    </div>
  </div>

</template>

<script>

export default {
  data() {
    return {
      pagesHeight: "",
      detailImgList: [
        {
          url: require("../assets/images/hc3620_top_001.png")
        }
      ]
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.pagesHeight = this.$refs.pagesRef.clientHeight;
    })

  },
}
</script>

<style lang="less" scoped>

@import "../assets/css/detailCommon";

@media screen and (max-width: 1280px) {

  .center_one_body_current {
    height: 540px;

    .oneBodyImgCls {
      width: 100%;
      height: 540px;
    }

  }

}

@media screen and (min-width: 1281px) and (max-width: 1440px) {

  .center_one_body_current {
    height: 620px;

    .oneBodyImgCls {
      width: 100%;
      height: 620px;
    }
  }

}

@media screen and (min-width: 1441px) and (max-width: 1920px) {

  .center_one_body_current {
    height: 814px;

    .oneBodyImgCls {
      width: 100%;
      height: 814px;
    }
  }
}

.center_one_body_current {
  display: flex;

  .oneBodyImgCls {
  }
}


</style>